import React, { useEffect, useRef, useState } from "react";
import Header from "../Components/Header/Header";
import { API } from "../constant";
import { authFetch } from "../helpers";
import { useAuthContext } from "../context/AuthContext";
import Loading from "../Components/Hooks/Loading";
import SkillItem from "../Components/Skills/SkillItem";
import Parser from 'html-react-parser';
import "./RCA.css";
import Footer from "../Components/Footer/Footer";

const RCA = () => {
    const [loading, setLoading] = useState(true);
    const { isLoading } = useAuthContext();
    const [fielddata, setfielddata] = useState([]);
    const [stepIndex, setStepIndex] = useState(0);
    const [rcaInfo, setRcaInfo] = useState({});
    const [rcaSteps, setRcaSteps] = useState([]);

    const [selectedTriggers, setSelectedTriggers] = useState([]);
    const [selectedEmotions, setSelectedEmotions] = useState([]);
    const [selectedImmediateThoughts, setSelectedImmediateThoughts] = useState([]);
    const [recommendedSkills, setRrecommendedSkills] = useState([]);
    const [isAnalyzing, setIsAnalyzing] = useState(false);
    const skillsRef = useRef(null);

    const stepClickHandler = (targetIndex) => {
        if (targetIndex > stepIndex) return;
        setStepIndex(targetIndex);
        apiCall(targetIndex);
        const element = document.getElementById("form-popup");
        if (element) {
            element.classList.add("active-form");
        }
    };

    const closeButtonHandler = (e) => {
        const element = e.target.closest(".form-popup");
        if (e.target.classList.contains('active-form')) {
            e.target.classList.remove('active-form');
        } else if (e.target.classList.contains('close-button') || e.target.tagName === "SPAN") {
            element.classList.remove("active-form");
        }
    };

    useEffect(() => {
        const fetchData = async () => {
            try {
                const rcaRes = await fetch(`${API}/rca?fields[0]=title&fields[1]=description&populate[0]=rca_steps.step_image`);
                const rcaData = await rcaRes.json();
                
                setRcaInfo({
                    title: rcaData.data.attributes.title,
                    description: rcaData.data.attributes.description[0].children[0].text,
                });

                const rcasteps = rcaData.data.attributes.rca_steps.map((item) => ({
                    title: item.title,
                    description: item.description[0].children[0].text,
                    image_url: item.step_image.data.attributes.url,
                }));
                setRcaSteps(rcasteps);

                const initialDataRes = await fetch(`${API}/triggers?pagination[pageSize]=100`);
                const initialData = await initialDataRes.json();
                setfielddata(initialData.data);

                setLoading(false);
            } catch (error) {
                console.error("Failed to fetch initial data:", error);
                setLoading(false);
            }
        };
        fetchData();
    }, []);

    useEffect(() => {
        if (recommendedSkills.length > 0 && skillsRef.current) {
            skillsRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
    }, [recommendedSkills]);

    const handleOnChange = (event) => {
        const { checked } = event.target;
        const data_id = Number(event.target.getAttribute("data_id"));
        const currentStepTitle = rcaSteps[stepIndex]?.title;

        let updater;
        switch (currentStepTitle) {
            case "Trigger":
                updater = setSelectedTriggers;
                break;
            case "Emotion":
                updater = setSelectedEmotions;
                break;
            case "Immediate Thought":
                updater = setSelectedImmediateThoughts;
                break;
            default:
                return;
        }

        updater((prevSelected) => {
            if (checked) {
                return [...prevSelected, data_id];
            } else {
                return prevSelected.filter((id) => id !== data_id);
            }
        });
    };

    const apiCall = async (currentStepIndex) => {
        let url = "";

        if (currentStepIndex === 0) {
            url = `${API}/triggers?pagination[pageSize]=100`;
        } else if (currentStepIndex === 1) {
            if (selectedTriggers.length === 0) return;
            url = `${API}/emotions?pagination[pageSize]=100`;
        } else if (currentStepIndex === 2) {
            if (selectedTriggers.length === 0) return;
            url = `${API}/immediate-thoughts?pagination[pageSize]=100`;
        }

        if (url) {
            try {
                const res = await fetch(url);
                const data = await res.json();
                setfielddata(data.data);
            } catch (error) {
                console.error("Error fetching data:", error);
            }
        }
    };

    const next = () => {
        const el = document.getElementById("form-popup");
        el.classList.remove("active-form");
        const nodeList = document.querySelectorAll(".check-boxes .checkbox");
        for (let i = 0; i < nodeList.length; i++) {
            nodeList[i].classList.remove("active");
        }
        if (preventNext()) {
            const newIndex = stepIndex + 1;
            setStepIndex(newIndex);
            apiCall(newIndex);
        }
    };
    
    const prev = () => {
        const el = document.getElementById("form-popup");
        el.classList.remove("active-form");
        if (stepIndex > 0) {
            const newIndex = stepIndex - 1;
            setStepIndex(newIndex);
            apiCall(newIndex);
        }
    };

    const preventNext = () => {
        if (stepIndex === 0) {
            return selectedTriggers.length > 0;
        }
        if (stepIndex === 1) {
            return selectedEmotions.length > 0;
        }
        if (stepIndex === 2) {
            return selectedImmediateThoughts.length > 0;
        }
        return false;
    };

    const onFinish = async (event) => {
        event.preventDefault();
        const element = document.getElementById("form-popup");
        if (element.classList.contains('active-form')) {
            element.classList.remove('active-form');
        }
        if (selectedImmediateThoughts.length > 0) {
            setIsAnalyzing(true);
            try {
                await new Promise(resolve => setTimeout(resolve, 2000));
                const thoughtFilters = selectedImmediateThoughts.map((id) => {
                    return `filters[immediate_thoughts][id][$in]=${id}`;
                }).join('&');
                const res = await authFetch(`${API}/skills?populate=*&${thoughtFilters}&pagination[pageSize]=100`);
                const data = await res.json();
                setRrecommendedSkills(data.data);
            } catch (error) {
                console.error("Error fetching skills:", error);
            } finally {
                setIsAnalyzing(false);
            }
        }
    };

    const insertSpaces = (string) => {
        string = string.replace(/([a-z])([A-Z])/g, '$1 $2');
        string = string.replace(/([A-Z])([A-Z][a-z])/g, '$1 $2');
        string = string.replace(/[_,-]/g, ' ');
        return string;
    };
    
    const checkIcon = (
        <div className="checked">
            <span className="checkmark">
                <div className="checkmark_stem"></div>
                <div className="checkmark_kick"></div>
            </span>
        </div>
    );

    const checkBoxClicked = (event)=>{
        const el = event.target.parentElement;
        el.classList.toggle("active");
    }

    if (loading || isLoading) {
        return <Loading />;
    }
    console.log("Selected Triggers: " + selectedTriggers);
    console.log("Selected Emotions: " + selectedEmotions);
    console.log("Selected Thoughts: " + selectedImmediateThoughts);
    return (
        <div className="skills activities">
            <div className="container">
                <Header title="Skills" />
                <div className="content-wrap bg-gradient-light rca-ativity">
                    <div className="content-wrap-inner">
                        <div className="description">{Parser(rcaInfo.description)}</div>
                        <div className="rca form-fields-area">
                            <div className="rca">
                                <div className="rca-graphic">
                                    <div className="rca-graphic-inner">
                                        <div className={`step rca-step-${stepIndex + 1}`}>
                                            <div className="rca-circle">
                                                <div className="rca-icon"><span className="icon-chain-analysis"></span></div>
                                                <div className="rca-item rca-item-1 rca-graphics-dot">
                                                    <div className="rca-graphics-dot-inner step-clickable" onClick={() => stepClickHandler(0)}>
                                                        <div className="content step-clickable" onClick={() => stepClickHandler(0)}>
                                                            <h4>IDENTIFY</h4>
                                                            <h2>Trigger</h2>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="rca-item rca-item-2 rca-graphics-dot">
                                                    <div className={`rca-graphics-dot-inner${stepIndex >= 1 ? ' step-clickable' : ''}`} onClick={() => stepClickHandler(1)}>
                                                        <div className={`content${stepIndex >= 1 ? ' step-clickable' : ''}`} onClick={() => stepClickHandler(1)}>
                                                            <h4>NAME</h4>
                                                            <h2>Emotion</h2>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="rca-item rca-item-3 rca-graphics-dot">
                                                    <div className={`rca-graphics-dot-inner${stepIndex >= 2 ? ' step-clickable' : ''}`} onClick={() => stepClickHandler(2)}>
                                                        <div className={`content${stepIndex >= 2 ? ' step-clickable' : ''}`} onClick={() => stepClickHandler(2)}>
                                                            <h4>OBSERVE</h4>
                                                            <h2>Thought</h2>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="rca-item rca-item-4 rca-graphics-dot">
                                                    <div className="rca-graphics-dot-inner">
                                                        <div className="content">
                                                            <h4>PRACTICE</h4>
                                                            <h2>Coping Skill</h2>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="rca-graphics-dot active">
                                                    <div className="rca-graphics-dot-inner"></div>
                                                </div>
                                                {/* <div className="rca-graphics-dot"></div> */}
                                            </div>
                                            
                                            {/* {rcaSteps[stepIndex] && <img src={rcaSteps[stepIndex].image_url} alt="RCA" />} */}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <form onSubmit={onFinish} id="create-course-form">
                                <div id={rcaSteps[stepIndex]?.title.toLowerCase()} className={`${rcaSteps[stepIndex]?.title.toLowerCase()} active`}>
                                    
                                    <div id="form-popup" className="form-popup bg-blue">
                                        <div className="form-popup-wrap bg-blue">
                                            <div id="check" className="check-wrap">
                                                <div onClick={closeButtonHandler} className="close-button"><span className="icon icon-close"></span></div>
                                                <h3>Start by identifying the {rcaSteps[stepIndex]?.title}(s): </h3>
                                                <div className="check-boxes">
                                                {fielddata.map((item, index) => (
                                                    <div key={index} onClick={(checkBoxClicked)} className="checkbox">
                                                        <label className="checkbox-label">
                                                            <input
                                                                className="checkbox-item"
                                                                id={item.id}
                                                                data_id={item.id}
                                                                type="checkbox"
                                                                name={item.attributes.title}
                                                                checked={
                                                                    (rcaSteps[stepIndex]?.title === "Trigger" && selectedTriggers.includes(item.id)) ||
                                                                    (rcaSteps[stepIndex]?.title === "Emotion" && selectedEmotions.includes(item.id)) ||
                                                                    (rcaSteps[stepIndex]?.title === "Immediate Thought" && selectedImmediateThoughts.includes(item.id))
                                                                }
                                                                onChange={handleOnChange}
                                                            />
                                                            {/* <span className="checkmark"></span> */}
                                                            {insertSpaces(item.attributes.title)}
                                                        </label>
                                                    </div>
                                                ))}
                                                </div>
                                            </div>
                                            <div className="form-footer">
                                                {/* {stepIndex !== 0 && <button className="button-left-arrow" type="button" onClick={prev}><span></span></button>} */}
                                                
                                                {rcaSteps.length > 0 && stepIndex === rcaSteps.length -1 ? (
                                                    // Show Submit button on the last step
                                                    <button
                                                        className={`button fade-in-right ${preventNext() ? "" : "disabled"}`}
                                                        type="submit"
                                                    ><span className="btn-icon btn-next"></span>
                                                        {/* Submit */}
                                                    </button>
                                                ) : (
                                                    // Show Next button on all other steps
                                                    <button
                                                        className={`button fade-in-left ${preventNext() ? "" : "disabled"}`}
                                                        type={"button"}
                                                        onClick={next}
                                                    >
                                                        <span className="btn-icon btn-next"></span>
                                                    </button>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </form>
                        </div>
                        {isAnalyzing && (
                            <div className="rca-analyzing">
                                <div className="rca-analyzing-spinner"></div>
                                <p>Analysing your responses...</p>
                            </div>
                        )}
                        {recommendedSkills && recommendedSkills.length > 0 && (
                        <div className="rca-skills" ref={skillsRef}>
                            <div className="form-area-inner">
                                <div className="skills">
                                    <div className="skills-inner">
                                        {recommendedSkills.map((item, index1) => (
                                            <SkillItem key={index1} SklItem={item.attributes} itemId={item.id} />
                                        ))}
                                    </div>
                                </div>
                            </div>
                        </div>
                        )}
                    </div>
                </div>
                <Footer />
            </div>
        </div>
    );
};

export default RCA;